/*
 * Copyright 2025, IntraLinks, Inc. All rights reserved.
 */

import {
  ISecurityFactor, ISecuritySetup, ISupportedFactor, ISecuritySetupOptions, IPhoneNumber
} from '../ISecuritySetup';
import BaseModel from './BaseModel';

export enum SecuritySetupType {
  AUTHENTICATOR = 'AUTHENTICATOR',
  EMAIL = 'EMAIL',
  PUSH_NOTIFICATION = 'PUSH_NOTIFICATION',
  SMS = 'SMS',
}

export enum AuthErrorKey {
  ResourceAlreadyExists = 'resourceAlreadyExists',
  ResourceForbidden = 'resourceForbidden',
  DefaultErrorMessage = 'defaultErrorMessage',
  DefaultSMSErrorMessage = 'defaultSMSErrorMessage',
  DefaultEmailErrorMessage = 'defaultEmailErrorMessage',
  DefaultSMSChallengeError = 'defaultSMSChallengeError',
  DefaultSMSVerifyError = 'defaultSMSVerifyError',
  DefaultChallengeError = 'defaultChallengeError'
}

export default class SecuritySetup extends BaseModel implements ISecuritySetup {
  factors: ISupportedFactor[];

  enrolledFactors: ISecurityFactor[];

  type: SecuritySetupType;

  status: string;

  level: number;

  userId: string;

  label?: string;

  phoneNumber?: IPhoneNumber;

  options: ISecuritySetupOptions;

  code: string;

  loaProof: string;

  constructor(props: ISecuritySetup) {
    super();
    const {
      id,
      factors,
      enrolledFactors,
      type,
      status,
      level,
      userId,
      label,
      phoneNumber,
      options,
      code,
      loaProof
    } = props;
    this.id = id;
    this.factors = factors;
    this.enrolledFactors = enrolledFactors;
    this.type = type;
    this.status = status;
    this.level = level;
    this.userId = userId;
    this.label = label;
    this.phoneNumber = phoneNumber;
    this.options = options;
    this.code = code;
    this.loaProof = loaProof;
  }
}
